import { useForm } from "@inertiajs/react";
import { Upload } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ImportUsersDialog() {
  const [open, setOpen] = useState(false);
  const { data, setData, post, processing, reset, errors } = useForm<{
    file: File | null;
  }>({
    file: null,
  });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!data.file) {
      toast.error("Por favor selecciona un archivo");
      return;
    }

    post("/users/import", {
      forceFormData: true,
      onSuccess: () => {
        setOpen(false);
        reset();
        toast.success("Usuarios importados correctamente");
      },
      onError: () => {
        toast.error("Ocurrió un error al importar los usuarios");
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">
          <Upload className="mr-2 h-4 w-4" />
          Importar
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>Importar Usuarios</DialogTitle>
            <DialogDescription>
              Sube un archivo CSV o Excel para importar usuarios masivamente.
              <br />
              Formato: &quot;nombre completo&quot;, &quot;email&quot;, &quot;password&quot;, &quot;grupos&quot;
              <br />
              <a
                href="/usuarios-import-ejemplo.csv"
                download
                className="mt-2 inline-block text-primary underline hover:text-primary/80"
              >
                Descargar archivo de ejemplo
              </a>
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid w-full max-w-sm items-center gap-1.5">
              <Label htmlFor="file">Archivo</Label>
              <Input
                id="file"
                type="file"
                accept=".csv, .xls, .xlsx"
                onChange={(e) => setData("file", e.target.files?.[0] ?? null)}
              />
              {errors.file && (
                <p className="text-sm text-destructive">{errors.file}</p>
              )}
            </div>
          </div>
          <DialogFooter>
            <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
              {processing && (
                <p className="text-sm text-muted-foreground">
                  Por favor espera mientras se cargan los usuarios...
                </p>
              )}
              <Button type="submit" disabled={processing}>
                {processing ? "Importando..." : "Importar"}
              </Button>
            </div>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
